import { PropsWithChildren } from 'react'

type GridProps = {}

export const Grid = ({ children }: PropsWithChildren<GridProps>) => {
  return <div className="flex min-h-[calc(100vh-52px)] w-full">{children}</div>
}
